import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ApiService } from '@services/api.service';
import { catchError, finalize, tap } from 'rxjs/operators';
import { of } from 'rxjs';

@Component({
  selector: 'ew-register-email',
  templateUrl: './register-email.component.html',
  styleUrl: './register-email.component.scss',
})
export class RegisterEmailComponent implements OnInit {
  form: FormGroup;
  loading: boolean = false;
  success: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      profile: any;
    },
    private dialogRef: MatDialogRef<RegisterEmailComponent>,
    private fb: FormBuilder,
    private api: ApiService,
  ) {
    this.form = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
    });
  }

  ngOnInit(): void {}

  get validations() {
    return [this.form.valid && !this.loading];
  }

  save(): void {
    if (this.form.invalid) {
      return;
    }

    this.loading = true;

    const profileId = this.data.profile.id;
    const url = `v1/invoices/profile/${profileId}/update`;

    this.api
      .put(url, {
        companyEmail: this.form.value.email,
      })
      .pipe(
        tap(() => {
          this.success = true;
          // Modal will be closed by the user after seeing the success message
        }),
        catchError(() => {
          return of(null);
        }),
        finalize(() => {
          this.loading = false;
        }),
      )
      .subscribe();
  }

  cancel(): void {
    this.dialogRef.close();
  }

  closeDialog(): void {
    this.dialogRef.close(true);
  }
}
